// SEO no app (05/10/2026) — endereços legíveis e metadados por tela.
//
// Os robôs (Googlebot, WhatsApp…) recebem o HTML pronto do servidor
// (/api/seo/render, via rewrite por user-agent no vercel.json). Aqui o app
// usa a MESMA URL e os mesmos títulos, pra pessoa e robô verem o mesmo:
// - anúncio:  /equipamento/<nome-cidade-uf>-<id>   (o link antigo /equipamento/<id> continua abrindo)
// - vitrines: /aluguel/<cidade-uf>[/<categoria>] e /categoria/<categoria>
// Antes, toda tela tinha o título "Tô Alugando — Marketplace de Locação P2P"
// e nenhuma tinha canonical.

export const BASE_URL = 'https://www.toalugando.com.br';

export const SEO_PADRAO = {
  titulo: 'Tô Alugando — Marketplace de Locação P2P',
  descricao: 'Alugue equipamentos, ferramentas, espaços e itens para eventos com identidade verificada, pagamento protegido e contrato com validade jurídica.',
};

// Telas públicas que podem aparecer na busca (as outras levam noindex) —
// título próprio quando faz sentido.
export const TELAS_PUBLICAS = {
  home: { caminho: '/' },
  regras: { caminho: '/como-funciona', titulo: 'Como funciona o aluguel no Tô Alugando' },
  termos: { caminho: '/termos', titulo: 'Termos de uso | Tô Alugando' },
  privacidade: { caminho: '/privacidade', titulo: 'Política de privacidade | Tô Alugando' },
  perfil_publico: { caminho: null },
  detalhes_pacote: { caminho: null },
};

/** 'Aparecida de Goiânia, GO' → 'aparecida-de-goiania-go'. Mesma conta do servidor (seo_service.slugify). */
export const slugify = (texto, limite = 80) => String(texto || '')
  .normalize('NFKD')
  // = encode('ascii', 'ignore') do Python: tudo fora do ASCII sai (acento,
  // travessão, U+2028…); o resto vira '-' na linha de baixo, igual lá.
  // eslint-disable-next-line no-control-regex
  .replace(/[^\x00-\x7f]/g, '')
  .replace(/[^a-zA-Z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '')
  .toLowerCase()
  .slice(0, limite)
  .replace(/-+$/, '');

const UUID_NO_FIM = /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/;

/** Id do anúncio a partir do último pedaço da URL (formato novo ou antigo). */
export const idDoSlugAnuncio = (slug) => {
  const m = UUID_NO_FIM.exec(String(slug || ''));
  return m ? m[1] : String(slug || '');
};

/** /equipamento/<nome-cidade-uf>-<id> — aceita item da API (cidade + uf) ou do card ('Cidade, UF'). */
export const caminhoAnuncio = (item) => {
  if (!item?.id) return '/equipamento';
  const cidade = String(item.cidade || '');
  const local = item.uf && !cidade.includes(',') ? `${cidade} ${item.uf}` : cidade;
  const base = slugify(`${item.nome || ''} ${local}`, 70);
  return base ? `/equipamento/${base}-${item.id}` : `/equipamento/${item.id}`;
};

export const ehCaminhoVitrine = (path) => /^\/(aluguel|categoria)\/[^/]/.test(String(path || ''));

const _upsert = (seletor, criar, atributo, valor) => {
  let el = document.head.querySelector(seletor);
  if (valor == null || valor === '') { if (el) el.remove(); return; }
  if (!el) { el = criar(); document.head.appendChild(el); }
  el.setAttribute(atributo, valor);
};
const _meta = (attr, chave) => () => { const m = document.createElement('meta'); m.setAttribute(attr, chave); return m; };

/**
 * Atualiza <title>, description, canonical, robots e og:* da página.
 * `canonical` relativo vira absoluto no domínio oficial (www).
 */
export const aplicarSeo = ({ titulo, descricao, canonical, robots } = {}) => {
  if (typeof document === 'undefined') return;
  const t = titulo || SEO_PADRAO.titulo;
  const d = descricao || SEO_PADRAO.descricao;
  const url = canonical ? (canonical.startsWith('http') ? canonical : BASE_URL + canonical) : null;
  document.title = t;
  _upsert('meta[name="description"]', _meta('name', 'description'), 'content', d);
  _upsert('meta[name="robots"]', _meta('name', 'robots'), 'content', robots || null);
  _upsert('link[rel="canonical"]', () => { const l = document.createElement('link'); l.setAttribute('rel', 'canonical'); return l; }, 'href', url);
  _upsert('meta[property="og:title"]', _meta('property', 'og:title'), 'content', t);
  _upsert('meta[property="og:description"]', _meta('property', 'og:description'), 'content', d);
  _upsert('meta[property="og:url"]', _meta('property', 'og:url'), 'content', url || BASE_URL);
};

/** Metadados de uma tela que não cuida do próprio SEO (início, termos, área logada). */
export const seoDaTela = (tela) => {
  const pub = TELAS_PUBLICAS[tela];
  if (!pub) return { robots: 'noindex' };          // área logada/fluxos: fora da busca
  return { titulo: pub.titulo, canonical: pub.caminho };
};
